/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Certificateid2Inputs */

const en__field_certificateid2 = /** @type {(inputs: _Field_Certificateid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Certificate`)
};

const de__field_certificateid2 = /** @type {(inputs: _Field_Certificateid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zertifikat`)
};

/**
* | output |
* | --- |
* | "Certificate" |
*
* @param {_Field_Certificateid2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_certificateid2 = /** @type {((inputs?: _Field_Certificateid2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Certificateid2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_certificateid2(inputs)
	return de__field_certificateid2(inputs)
});
export { _field_certificateid2 as "_field_certificateID" }